import { Commission } from '../types/commission'

export const MOCK_COMMISSIONS: Commission[] = [
  {
    userId: 'u1',
    userName: 'Katrina Bullock',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 3,
    total: 4950.0,
    lateCount: 0,
    originalTier: 3,
    currentTier: 4,
    gainAmount: 700.0,
    loans: [
      {
        loanId: 'LN-2025-001',
        amount: 350000,
        tier: 4,
        commission: 1750.0,
        date: '2025-12-05',
      },
      {
        loanId: 'LN-2025-002',
        amount: 280000,
        tier: 4,
        commission: 1400.0,
        date: '2025-12-12',
      },
      {
        loanId: 'LN-2025-003',
        amount: 410000,
        tier: 4,
        commission: 1800.0,
        date: '2025-12-20',
      },
    ],
  },
  {
    userId: 'u2',
    userName: 'Lucas Rohr',
    userProfile: 'Sales Team Leader',
    payPeriod: 'December 2025',
    units: 2,
    total: 3100.0,
    lateCount: 1,
    loans: [
      {
        loanId: 'LN-2025-004',
        amount: 550000,
        tier: 5,
        commission: 2100.0,
        date: '2025-12-02',
      },
      {
        loanId: 'LN-2025-005',
        amount: 220000,
        tier: 5,
        commission: 1000.0,
        date: '2025-12-15',
      },
    ],
  },
  {
    userId: 'u3',
    userName: 'Bianca Payton',
    userProfile: 'Division Leader',
    payPeriod: 'December 2025',
    units: 1,
    total: 1800.0,
    lateCount: 0,
    loans: [
      {
        loanId: 'LN-2025-006',
        amount: 480000,
        tier: 5,
        commission: 1800.0,
        date: '2025-12-10',
      },
    ],
  },
  {
    userId: 'u4',
    userName: 'Antonio Hayes',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 0,
    total: 0.0,
    lateCount: 0,
    loans: [],
  },
  {
    userId: 'u5',
    userName: 'Melanie Rayis',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 8,
    total: 10800.0,
    lateCount: 4,
    originalTier: 4,
    currentTier: 3,
    lossAmount: 1600.0,
    loans: [
      {
        loanId: 'LN-2025-007',
        amount: 300000,
        tier: 3,
        commission: 1050.0,
        date: '2025-12-01',
      },
      {
        loanId: 'LN-2025-008',
        amount: 320000,
        tier: 3,
        commission: 1120.0,
        date: '2025-12-03',
      },
      {
        loanId: 'LN-2025-009',
        amount: 450000,
        tier: 3,
        commission: 1575.0,
        date: '2025-12-08',
      },
      {
        loanId: 'LN-2025-010',
        amount: 280000,
        tier: 3,
        commission: 980.0,
        date: '2025-12-11',
      },
      {
        loanId: 'LN-2025-011',
        amount: 390000,
        tier: 3,
        commission: 1365.0,
        date: '2025-12-15',
      },
      {
        loanId: 'LN-2025-012',
        amount: 510000,
        tier: 3,
        commission: 1785.0,
        date: '2025-12-18',
      },
      {
        loanId: 'LN-2025-013',
        amount: 250000,
        tier: 3,
        commission: 875.0,
        date: '2025-12-22',
      },
      {
        loanId: 'LN-2025-014',
        amount: 550000,
        tier: 3,
        commission: 2050.0,
        date: '2025-12-28',
      },
    ],
  },
  {
    userId: 'u6',
    userName: 'Zaid Shuwayhat',
    userProfile: 'Sales Team Leader',
    payPeriod: 'December 2025',
    units: 2,
    total: 2800.0,
    lateCount: 2,
    loans: [
      {
        loanId: 'LN-2025-015',
        amount: 300000,
        tier: 5,
        commission: 1400.0,
        date: '2025-12-05',
      },
      {
        loanId: 'LN-2025-016',
        amount: 300000,
        tier: 5,
        commission: 1400.0,
        date: '2025-12-20',
      },
    ],
  },
  {
    userId: 'u7',
    userName: 'Daniel McCarthy',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 3,
    total: 4200.0,
    lateCount: 1,
    originalTier: 2,
    currentTier: 3,
    gainAmount: 300.0,
    loans: [
      {
        loanId: 'LN-2025-017',
        amount: 320000,
        tier: 3,
        commission: 1400.0,
        date: '2025-12-04',
      },
      {
        loanId: 'LN-2025-018',
        amount: 320000,
        tier: 3,
        commission: 1400.0,
        date: '2025-12-14',
      },
      {
        loanId: 'LN-2025-019',
        amount: 320000,
        tier: 3,
        commission: 1400.0,
        date: '2025-12-24',
      },
    ],
  },
  {
    userId: 'u8',
    userName: 'Mike Kounini',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 0,
    total: 0.0,
    lateCount: 0,
    loans: [],
  },
  {
    userId: 'u9',
    userName: 'LaMonte Stinnette',
    userProfile: 'Division Leader',
    payPeriod: 'December 2025',
    units: 2,
    total: 4500.0,
    lateCount: 0,
    loans: [
      {
        loanId: 'LN-2025-020',
        amount: 600000,
        tier: 5,
        commission: 2500.0,
        date: '2025-12-10',
      },
      {
        loanId: 'LN-2025-021',
        amount: 500000,
        tier: 5,
        commission: 2000.0,
        date: '2025-12-25',
      },
    ],
  },
  {
    userId: 'u10',
    userName: 'Charles Ryle',
    userProfile: 'Loan Officer',
    payPeriod: 'December 2025',
    units: 3,
    total: 3600.0,
    lateCount: 2,
    loans: [
      {
        loanId: 'LN-2025-022',
        amount: 300000,
        tier: 2,
        commission: 1200.0,
        date: '2025-12-02',
      },
      {
        loanId: 'LN-2025-023',
        amount: 300000,
        tier: 2,
        commission: 1200.0,
        date: '2025-12-12',
      },
      {
        loanId: 'LN-2025-024',
        amount: 300000,
        tier: 2,
        commission: 1200.0,
        date: '2025-12-22',
      },
    ],
  },
]
